/// <amd-module name="Tfs/Frame/Components/Help/MenuIcon" />
import * as React from "react";
import { Icon, IconSize } from "VSSUI/Icon";
import { ITooltipProps } from "VSSUI/TooltipEx";

export interface IMenuIconProps {
    onComponentRendered: () => void;
    iconName: string;
    tooltipProps?: ITooltipProps;
}

export const MenuIcon: React.FunctionComponent<IMenuIconProps> = ({ onComponentRendered, iconName, tooltipProps }) => {
    React.useEffect(() => {
        if (onComponentRendered) {
            onComponentRendered();
        }
    });
    return <Icon iconName={iconName} size={IconSize.medium} tooltipProps={tooltipProps} />;
};
